<template>
    <div data-app>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="12" sm="6" md="6" style="color: #e33354" class="ml-4">
                         <h3>{{ cardTitle }}</h3>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field
                          v-model="search"
                          append-icon="search"
                          :label="$t('FORMS.search')"
                          single-line
                          hide-details
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="bannerCampaignCollection"
                    :search="search"
                    :sort-by="['id']"
                    sort-desc="true"
                    :loading="loadingTable"
                    @click:row="handleClickItem"
                >
                    <template v-slot:top>
                        <v-toolbar flat>
                            <BannerCampaignModalForm
                              :modalData="modalData"
                              :permissions="permissions"
                              :endPoint="endPoint"
                              @closeModalForm="handleCloseModalForm"
                              @saveModalForm="handleSaveModalForm"
                              @new="handleNew"
                            ></BannerCampaignModalForm>
                            <v-spacer></v-spacer>
                            <DeleteModalDialog
                              :dialogDelete="dialogDelete"
                              @closeDelete="handleCloseDelete"
                              @deleteItemConfirm="handleDeleteItemConfirm"
                            >
                            </DeleteModalDialog>
                        </v-toolbar>
                    </template> 
                    
                    <template v-slot:item.banner_client_id="{ item }">
                        {{ getBannerCampaignName(item.banner_client_id) }}
                    </template>
                    
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                          color="primary"
                          v-if="permissionCan('delete') && item.deletable"
                          small
                          @click="deleteItem(item)"
                        >
                          mdi-delete
                        </v-icon>
                    </template>
                    
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SiteService from "@/core/services/site.service.js";
import { listModelsMixins } from "@/view/mixins/listModelsMixins.js";
import BannerCampaignModalForm, { initialFormData } from "./BannerCampaignModalForm";
import DeleteModalDialog from "@/view/components/DeleteModalDialog";
export const PERMISSION_TO = "pages.bannerCampaign.";
export default {
    name: "BannerCampaigns",
    components: { BannerCampaignModalForm, DeleteModalDialog },
    mixins: [listModelsMixins],
    data() {
      return {
        cardTitle: this.$t("MENU.bannerCampaigns"),
        search: "",
        routePath: "/cms/banners/bannerCampaigns/",
        permissionTo: PERMISSION_TO,
        permissions: JSON.parse(localStorage.permissions),
        headers: [
          {
            text: this.$t("TABLE.name"),
            value: "name",
          },
          {
            text: this.$t("TABLE.banner_client"),
            value: "banner_client_id",
          },
          { text: "Actions", value: "actions", sortable: false, width: "100px" },
        ],

        modalData: {
            dialog: false,
            editedId: null,
        },
        editedItem: Object.assign({}, initialFormData()),
        dialogDelete: false,
        };
    },

    computed: {
      ...mapGetters(["bannerCampaignCollection","getBannerClientByID"]),

      endPoint() {
        return "pages/admin/" + SiteService.getActiveSiteId() + "/bannerCampaign/";
      },
    },
    
    watch: {
        dialogDelete(val) {
          val || this.handleCloseDelete();
        },
        "$route.params.id": {
          handler: function (id) {
            if (id) {
              this.editItem(id);
            }
          },
          deep: true,
          immediate: true,
        },
    },

   
    methods: {
        ...mapActions(["fetchBannerCampaign"]),
        fetchModel() {
            return this.fetchBannerCampaign();
            //this.fetchBannerCampaign();  
        },
        getBannerCampaignName(banner_campaign_id) {
            let banner_campaign = this.getBannerClientByID(banner_campaign_id);
            if (banner_campaign) {
              return (
                banner_campaign.name
              );
            }
            return "";
          },
    },

    mounted() {
      this.loadingTable = true;
      this.fetchModel().then(() => (this.loadingTable = false));
    },
};
</script>